module.exports = "/assets/js/2b9e48f56581a33a0a5fcadd2a524083.svg";